import React, { useEffect, useRef } from 'react'

const useInterval = (
  callback: React.EffectCallback,
  delay: number | null
): React.MutableRefObject<number | null> => {
  const intervalRef = useRef<number | null>(null)
  const callbackRef = useRef(callback)

  useEffect(() => {
    callbackRef.current = callback
  }, [callback])

  useEffect(() => {
    if (typeof delay === 'number') {
      intervalRef.current = window.setInterval(() => callbackRef.current(), delay)

      return () => window.clearInterval(intervalRef.current || 0)
    }

    return undefined
  }, [delay])

  return intervalRef
}

export default useInterval
